import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { GuestRefundService } from '../guest-refund.service';
import { GuestRefund } from '../guest-refund';
import { PropertyService } from '@app/_components/property';
import { ConstantService } from '@app/_services/constant.service';
import { ReservationService } from '@app/_components/reservation';

@Component({
    selector: 'app-guest-refund',
    templateUrl: './guest-refund.component.html',
    styleUrls: ['./guest-refund.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class GuestRefundComponent implements OnInit {
	properties: any;
    reasonCodes: any;
    countries: any;
    guestLastName: any;
    reservationId: any;
    states: any[];
	title = "Reservation";
	isReservationId = false;
    reservation: any;
    totalRefundAmounts: any;

	constructor(
		private reservationService: ReservationService,
		private constantService: ConstantService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private guestRefundService: GuestRefundService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title;
			this.guestRefund = data.guestRefund;
			this.guestLastName = data.guestRefund?.lastName;
			this.guestRefundId = data.guestRefund?.guestRefundId;
			this.reservationId = data.guestRefund?.reservationId;
			console.log("this.reservationId :"+this.reservationId);
			/*if(data.guestRefund.checkInDate != undefined && data.guestRefund.checkInDate != null){
				this.guestRefund.checkInDate = moment(data.guestRefund.checkInDate).toDate();
			}
			if(data.guestRefund.checkOutDate != undefined && data.guestRefund.checkOutDate != null){
				this.guestRefund.checkOutDate = moment(data.guestRefund.checkOutDate).toDate();
			}
			if(data.guestRefund.actualCheckInDate != undefined && data.guestRefund.actualCheckInDate != null){
				this.guestRefund.actualCheckInDate = moment(data.guestRefund.actualCheckInDate).toDate();
			}
			if(data.guestRefund.actualCheckOutDate != undefined && data.guestRefund.actualCheckOutDate != null){
				this.guestRefund.actualCheckOutDate = moment(data.guestRefund.actualCheckOutDate).toDate();
			}*/
			this.statuses = guestRefundService.statuses;
			this.reasonCodes = guestRefundService.reasonCodes;
			this.countries = this.constantService.countries; 
			this.states = this.constantService.states;
	}

	@Input() guestRefund: GuestRefund;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	dynamicArray: Array<any> = [];
	newDynamic: any = {};

	// data
	guestRefundId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: 'add' | 'update' | 'delete' | null = null;
	addCompleted = false; // true after a successful add — keeps Add button disabled without holding the spinner
	formAlert: String;
	formTitle: String;

	statuses: any;
	sendingCreditAuth = false;
	creditAuthSent = false;
	noRefundAmountsError = false;
	showProcessRefundDialog = false;
	processRefundPassword = '';
	processingRefund = false;
	refundCardInfo: { cards: any[]; hasCards: boolean } | null = null;
	selectedPaymentSourceId: number | null = null;
	loadingCardInfo = false;

	activeTabIndex = 0;

	validationMessages = {
		'guestRefundId': [],
		'firstName': [{ type: 'required', message: 'Required' },
		{ type: 'minlength', message: '2 characters minimum' }],
		'lastName': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '2 characters minimum' }],
		'shortTermRentalId': [{ type: 'required', message: 'Required' }],
		'propertyCode': [],
		'status': [{ type: 'required', message: 'Required' }],
		'mobilePhone': [],
		'emailAddress': [{ type: 'required', message: 'Required' }, { type: 'email', message: 'Please enter valid email' }],
		'adr1': [],
		'adr2': [],
		'adrCity': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrCountry': [],
		'checkInDate': [],
		'checkOutDate': [],
		'actualCheckInDate': [],
		'actualCheckOutDate': [],
		'reservationId': [],
		'issueDesc': [{ type: 'required', message: 'Required' }],
		'refundAmountTTL': [],
		'submittedDate': [],
		'creditAuthSendDate': [],
		'creditAuthRcvDate': [],
		'acctRcvDate': [],
		'acctProcessDate': [],
		'guestRcvFundsEstDate': [],
		'orderId': [],
	};

	ngOnInit() {
		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();

		this.newDynamic = { guestRefundReasonId: "", reasonCode: "", reasonDesc: "", refundAmount: "" };
		this.dynamicArray.push(this.newDynamic);

		// if we were passed the whole guestRefund object
		if (this.guestRefund) {
			this.guestRefundId = this.guestRefund.guestRefundId;
			console.log("this.guestRefund.guestRefundId : "+this.guestRefund.guestRefundId);
			if(this.guestRefund.checkInDate != undefined && this.guestRefund.checkInDate != null){
				this.guestRefund.checkInDate = moment(this.guestRefund.checkInDate).toDate();
			}
			if(this.guestRefund.checkOutDate != undefined && this.guestRefund.checkOutDate != null){
				this.guestRefund.checkOutDate = moment(this.guestRefund.checkOutDate).toDate();
			}
			if(this.guestRefund.actualCheckInDate != undefined && this.guestRefund.actualCheckInDate != null){
				this.guestRefund.actualCheckInDate = moment(this.guestRefund.actualCheckInDate).toDate();
			}
			if(this.guestRefund.actualCheckOutDate != undefined && this.guestRefund.actualCheckOutDate != null){
				this.guestRefund.actualCheckOutDate = moment(this.guestRefund.actualCheckOutDate).toDate();
			}
			if(this.guestRefund.submittedDate != undefined && this.guestRefund.submittedDate != null){
				this.guestRefund.submittedDate = moment(this.guestRefund.submittedDate).toDate();
			}
			if(this.guestRefund.creditAuthSendDate != undefined && this.guestRefund.creditAuthSendDate != null){
				this.guestRefund.creditAuthSendDate = moment(this.guestRefund.creditAuthSendDate).toDate();
			}
			if(this.guestRefund.creditAuthRcvDate != undefined && this.guestRefund.creditAuthRcvDate != null){
				this.guestRefund.creditAuthRcvDate = moment(this.guestRefund.creditAuthRcvDate).toDate();
			}
			if(this.guestRefund.acctRcvDate != undefined && this.guestRefund.acctRcvDate != null){
				this.guestRefund.acctRcvDate = moment(this.guestRefund.acctRcvDate).toDate();
			}
			if(this.guestRefund.acctProcessDate != undefined && this.guestRefund.acctProcessDate != null){
				this.guestRefund.acctProcessDate = moment(this.guestRefund.acctProcessDate).toDate();
			}
			if(this.guestRefund.guestRcvFundsEstDate != undefined && this.guestRefund.guestRcvFundsEstDate != null){
				this.guestRefund.guestRcvFundsEstDate = moment(this.guestRefund.guestRcvFundsEstDate).toDate();
			}
			this.fixDates();
			this.form1.patchValue(this.guestRefund);
		}
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	onFormDelete() {
		if (this.formLoading) {
			return;
		}
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.guestRefundId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			if (this.formLoading) {
				return;
			}
			this.form1.value.reservationId = this.reservationId;
			if (this.form1.value.reservationId == null) {
				this.isReservationId = true;
				return;
			}
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.formAction = 'add';
			this.form1.value.reservationId = this.reservationId;
			if (this.form1.value.reservationId == null) {
				this.formLoading = false;
				this.formAction = null;
				return;
			}
			this.guestRefundService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestRefund = res.data.guestRefund;
						this.guestRefundId = this.guestRefund.guestRefundId;
						this.form1.patchValue({ guestRefundId: this.guestRefundId });
						this.doAdd.emit(this.guestRefund);
						// Mark add as completed so the Add button stays disabled,
						// but reset formLoading so the spinner stops.
						this.addCompleted = true;
						this.formLoading = false;
						this.formAction = null;
					},
					(err: any) => {
						console.log('guestRefund-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.formLoading = false;
						this.formAction = null;
					});

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('guestRefund: ' + JSON.stringify(this.form1.value));
		try {
			if (this.formLoading) {
				return;
			}
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			// require at least one refund amount
			if (!this.form1.get('refundAmountTTL').value || +this.form1.get('refundAmountTTL').value <= 0) {
				this.noRefundAmountsError = true;
				return;
			}
			this.noRefundAmountsError = false;
			this.formLoading = true;
			this.formAction = 'update';
			if (!this.form1.value.guestRefundId && this.guestRefundId) {
				this.form1.patchValue({ guestRefundId: this.guestRefundId });
			}

			this.guestRefundService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestRefund = res.data.guestRefund;
						this.doUpdate.emit(this.guestRefund);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.formLoading = false;
						this.formAction = null;
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			if (this.formLoading) {
				return;
			}
			this.formLoading = true;
			this.formAction = 'delete';
			this.guestRefundService.delete(this.guestRefund.guestRefundId)
				.subscribe(
					(res: any) => {
						console.log('guestRefund-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						// Parent handles list refresh and closes this dialog on delete event.
						this.doDelete.emit(this.guestRefund);
					},
					(err: any) => {
						console.log('guestRefund-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.formLoading = false;
						this.formAction = null;
					});
		} catch (error) {
			this.alertService.error(error);
			this.formLoading = false;
			this.formAction = null;
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			guestRefundId: [this.guestRefundId],
			firstName: ['', Validators.compose(
				[
					Validators.minLength(2),
					Validators.required
				])],
			lastName: ['', Validators.compose(
				[
					Validators.minLength(2),
					Validators.required
				])],
			shortTermRentalId: ['', Validators.required],
			propertyCode: [],
			status: ['0'],
			mobilePhone: [],
			emailAddress: ['', Validators.compose([Validators.email, Validators.required])],
			adr1: [],
			adr2: [],
			adrCity: [],
			adrState: [],
			adrPostalCode: [],
			adrCountry: [],
			checkInDate: [],
			checkOutDate: [],
			actualCheckInDate: [],
			actualCheckOutDate: [],
			reservationId: [],
			issueDesc: [this.guestRefund?.issueDesc || '', Validators.required],
			refundAmountTTL: [],
			submittedDate: [],
			creditAuthSendDate: [],
			creditAuthRcvDate: [],
			acctRcvDate: [],
			acctProcessDate: [],
			guestRcvFundsEstDate: [],
			guestRefundReasons: this.formBuilder.array([]),
			orderId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.guestRefund.guestRefundDate = moment(this.guestRefund.guestRefundDate).toDate();
	}
	
	reservationInfoItem(event : any){
		console.log("reservation reservation : "+ JSON.stringify(event));
		this.isReservationId = false;
		this.reservationId = event.reservationId;
		this.fetchReservationById(this.reservationId);
	}
	
	fetchReservationById(reservationId: any) {
			try {
				this.reservationService.findById(reservationId)
					.subscribe(
						res => {
							console.log('findById reservation : ' + JSON.stringify(res));
							this.reservation = res.data.reservation;
							this.form1.patchValue({
								firstName: this.reservation.guestProfile.firstName,
								lastName: this.reservation.guestProfile.lastName,
								emailAddress: this.reservation.guestProfile.emailAddress,
								adr1: this.reservation.guestProfile.adrStreet,
								adr2: this.reservation.guestProfile.adrStreet2,
								adrCity: this.reservation.guestProfile.adrCity,
								adrState: this.reservation.guestProfile.adrState,
								adrCountry: this.reservation.guestProfile.adrCountry,
								mobilePhone: this.reservation.primaryMobilePhone,
								checkInDate: moment(this.reservation.checkInDate).toDate(),
								checkOutDate: moment(this.reservation.checkOutDate).toDate(),
								shortTermRentalId: this.reservation.shortTermRental.shortTermRentalId,
								propertyCode: this.reservation.shortTermRental.propertyCode,
								orderId: this.reservation?.order?.orderId
							});
							return this.reservation;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		
		totalRefundAmount(amount: any){
			this.totalRefundAmounts = amount;
			this.form1.patchValue({
				refundAmountTTL: amount
			});
			if (amount > 0) {
				this.noRefundAmountsError = false;
			}
		}
		
		totalRefundAmountDeduct(amount: any){
			this.form1.patchValue({
				refundAmountTTL: this.totalRefundAmounts - amount
			});
		}

		onSendCreditAuth(): void {
			if (this.sendingCreditAuth) return;
			this.sendingCreditAuth = true;
			this.creditAuthSent = false;
			this.guestRefundService.sendCreditAuth(this.guestRefundId).subscribe({
				next: (res: any) => {
					// res is null when the error interceptor swallows a 401 (session expired /
					// token rejected) and returns of(null) instead of calling the error handler.
					// In that case the interceptor already redirects to login — just reset state.
					if (!res) {
						this.sendingCreditAuth = false;
						return;
					}
					this.messageService.add({ severity: 'success', summary: 'Sent', detail: res.message || 'Credit auth link sent.', life: 5000 });
					this.form1.patchValue({ status: '1' });
					this.creditAuthSent = true;
					this.sendingCreditAuth = false;
					this.guestRefund = { ...this.guestRefund, status: '1' };
					this.doUpdate.emit(this.guestRefund);
				},
				error: (err: any) => {
					const detail = (typeof err === 'string' && err) || err?.message || err?.error?.message || 'Could not send credit auth.';
					this.messageService.add({ severity: 'error', summary: 'Failed', detail, life: 5000 });
					this.sendingCreditAuth = false;
				}
			});
		}

		onProcessRefundClick(): void {
			this.processRefundPassword = '';
			this.refundCardInfo = null;
			this.selectedPaymentSourceId = null;
			this.loadingCardInfo = true;
			this.showProcessRefundDialog = true;
			this.guestRefundService.getRefundPaymentInfo(this.guestRefundId).subscribe({
				next: (res: any) => {
					const cards = res?.data?.paymentInfo?.cards || [];
					this.refundCardInfo = { cards, hasCards: cards.length > 0 };
					this.loadingCardInfo = false;
				},
				error: () => {
					this.refundCardInfo = { cards: [], hasCards: false };
					this.loadingCardInfo = false;
				}
			});
		}

		onConfirmProcessRefund(): void {
			if (!this.processRefundPassword) return;
			this.processingRefund = true;
			this.guestRefundService.processRefund(this.guestRefundId, this.processRefundPassword, this.selectedPaymentSourceId).subscribe({
				next: (res: any) => {
					this.messageService.add({ severity: 'success', summary: 'Refund Processed', detail: res.message || 'Refund marked as processed.', life: 6000 });
					this.form1.patchValue({ status: '3' });
					this.guestRefund = { ...this.guestRefund, status: '3' };
					this.doUpdate.emit(this.guestRefund);
					this.showProcessRefundDialog = false;
					this.processingRefund = false;
				},
				error: (err: any) => {
					const msg = err?.error?.message || 'Could not process refund.';
					this.messageService.add({ severity: 'error', summary: 'Failed', detail: msg, life: 6000 });
					this.processingRefund = false;
				}
			});
		}

}
